import React from 'react';
import * as Yup from 'yup';

/** ************* COMPONENTS  ******************** */
import Card from 'components/Cards/Card';
import {
    Box,SimpleGrid, Button,Icon ,
    FormControl,
    Input,
    FormLabel,
    VStack,
    InputGroup,
    InputLeftElement,
    FormErrorMessage,
    HStack,
    Checkbox
} from '@chakra-ui/react';
// import CompanyDocuments from './Tabs/companyDocuments';
import CompanyDetails from './Tabs/companyDetails';
import BackButton from 'components/Button/BackButton';
import AddressInput from 'components/Forms/AddressInput';
import SelectInput from 'components/Input/SelectInput';
import statelist from 'constants/Select-constants/stateslist.json';
import RefreshIcon from 'components/icons/RefreshIcon';
import { mapResponseToDefaults } from 'utils/default-util';
/** ******************  APIES  ************************************* */
import { useGetCompanyQueryQuery, useUpdateCompanyMutation } from 'reducers/company.service';
import { useParams, useHistory } from 'react-router-dom/cjs/react-router-dom';
import { Formik,Form, useField } from 'formik';
import { CiEdit } from 'react-icons/ci';
import { COMPANY_DEFAULT_DATA } from 'constants/lender-defaults';
import { viewDate } from 'utils/date';

const TextField = ({ label, type = 'text' , ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <InputGroup>
                {label === 'Website' && (
                    <InputLeftElement width={'4rem'} pointerEvents="none">
                        <p style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}>https://</p>
                    </InputLeftElement>
                )}
                <Input pl={label === 'Website' ? '4rem' : undefined} {...field} {...props} type={type} />
            </InputGroup>
            {/* <Input startElement={ label === 'website' ? <p>HTTPS</p> : null} {...field} {...props} /> */}
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};
const CheckboxField = ({ children, ...props }) => {
    const [field, , helpers] = useField({ ...props, type: 'checkbox' });

    return (
        <Checkbox
            isChecked={field.value}
            onChange={(e) => helpers.setValue(e.target.checked)}
            {...field}
            {...props}
        >
            {children}
        </Checkbox>
    );
};

/** **************************** COMPONENT START FROM HERE  ******************* */
const ViewCompany = () => {
    let { id } = useParams();
    const { data, refetch,isLoading,isError } = useGetCompanyQueryQuery(id);
    const [updateCompany] = useUpdateCompanyMutation();

    const history = useHistory();
    const searchparams = new URLSearchParams(history.location.search);
    const isEdit = searchparams.get('isEdit') === 'true';

    const handleEdit = ()=>{
        setisEdit(!isEdit);
    };

    const setisEdit = ()=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('isEdit', !isEdit);

        // history replace
        history.replace({
            pathname: location.pathname,
            search: searchParams.toString()
        });
    };
    const handleUpdate = (values, actions)=>{
        // values.Statelicenses = values.Statelicenses.map((row)=> row?.value || row);

        updateCompany({ id, body: { ...values ,dateFormed: viewDate(values?.dateFormed) } }).unwrap().then(()=>{
            refetch();
            setisEdit(false);
        });
    };

    return (
        <Box pt={{ base: '130px', md: '80px', xl: '65px' }}>
            <SimpleGrid
                mb="20px"
                columns={{ sm: 1, md: 1 }}
                spacing={{ base: '20px', xl: '20px' }}
            >
                <Card>
                    <div className="page-head-box space-between-box">
                        <div className="start-box">
                            <BackButton/>
                            <p>View Company</p>
                        </div>
                        <div>
                            <Button onClick={handleEdit} style={{ fontSize: '13px', color: 'teal' }}>
                                {
                                    isEdit
                                        ? <>
                                                                        Cancel
                                        </>
                                        : <>
                                            <Icon as={CiEdit} w={4} h={4} mr={1} />
                                                                                Edit Details

                                        </>
                                }
                            </Button>

                            <RefreshIcon handleRefresh={refetch}/>
                        </div>
                    </div>

                    {
                        isEdit
                            ? <Formik
                                initialValues={mapResponseToDefaults(COMPANY_DEFAULT_DATA , data)}
                                validationSchema={Yup.object({
                                })}
                                onSubmit={handleUpdate}
                            >
                                {({ handleSubmit, values , setValues, setFieldValue }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <VStack align="stretch" spacing={4}>
                                            <TextField name="name" label="Name" />
                                            <TextField name="NMLS" label="NMLS" />
                                            <TextField name="email" label="Email" />
                                            <TextField name="phone" label="Phone" />
                                            <TextField name="website" label="Website" />
                                            <TextField name="fax" label="Fax" />
                                            <TextField name="FormedIn" label="Formed In" type='text' />
                                            <TextField name="dateFormed" label="Date of Formed" type='date' />

                                            <SelectInput
                                                issearch={true}
                                                name={'Statelicenses'}
                                                isMulti ={true}
                                                required={true}
                                                label={'State Licenses'}
                                                options={statelist}
                                                defaultValue={[]}
                                            />

                                            <Box>
                                                <AddressInput />
                                            </Box>
                                            <FormControl>

                                                <CheckboxField name="isMailingAddressEqualPhysical">
                                            The address and mailing address is same.
                                                </CheckboxField>
                                            </FormControl>

                                            {
                                                !values?.isMailingAddressEqualPhysical && <AddressInput name='mailingaddress' label='Mailing Address' />
                                            }
                                            <HStack justify="flex-end" gap={'0.5rem'}>
                                                <Button variant="outline" type="reset" onClick={handleEdit }>
                                                            Cancel
                                                </Button>
                                                <Button disabled={isLoading} colorScheme="blue" type="submit">
                                                    {
                                                        isLoading ? 'Saving...' : 'Save'
                                                    }
                                                </Button>
                                            </HStack>
                                        </VStack>
                                    </Form>
                                )}
                            </Formik>
                            : <CompanyDetails data={data} isLoading={isLoading} isError={isError} refetch={refetch} />
                    }
                    {/* <Tabs>
                        <TabList w={'100%'}>
                            <Tab w={'50%'}>Company Details</Tab>
                            <Tab w={'50%'}>Documents</Tab>
                        </TabList>
                        <TabPanels>
                            <TabPanel>
                                <CompanyDetails data={data} isLoading={isLoading} isError={isError} refetch={refetch} />
                            </TabPanel>
                            <TabPanel>
                                <CompanyDocuments data={data?.companyDoc} isLoading={isLoading} isError={isError} refetch={refetch} />
                            </TabPanel>
                        </TabPanels>
                    </Tabs> */}
                </Card>
            </SimpleGrid>
        </Box>
    );
};

export default ViewCompany;
